module.exports = __webpack_public_path__ + "img/mc.8344e47d.svg";